// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2RIEy","messages":"Chat_messages__1gZpv","dateDivider":"Chat_dateDivider__1JAgV"};